// extracted by mini-css-extract-plugin
export default {"blue-summary-container":"MainApp_organisms_BlueSummary_blue-summary-container__LChFl"};